import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { LoanChecklistRule } from '../loans/types';
import { rulesMockData } from '../utils/checklist.mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

interface GlobalRulesResponse {
  data: LoanChecklistRule[];
  success: boolean;
}

export interface GlobalRulesParams {
  searchTerm: string;
}

const getGlobalRules: QueryFunction<
  LoanChecklistRule[],
  ['/global/rules', string]
> = async ({ queryKey }) => {
  if (isMockServices()) {
    const mockData = rulesMockData().filter((rule) =>
      rule.name.toLowerCase().includes(queryKey[1].toLowerCase()),
    );
    return await mock(mockData, { delay: 1000 });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GlobalRulesResponse>(
    `/shared/rules/search?searchTerm=${queryKey[1]}`,
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data.data ?? [];

  throw new Error('Failed to fetch global rules');
};

export default getGlobalRules;
